import { CompanyActivity, EmploymentStatus, ProfessionalPosition } from '@nemuru-eng/js-api-client';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

export const EMPLOYMENT_STATUS_TYPE_ARRAY = (t: GetTextIdTranslationType) =>
  Object.keys(EmploymentStatus).map((status) => ({
    value: status.toLowerCase(),
    display: t(status.toLowerCase()) || status.toLowerCase(),
  }));

export const PROFESSIONAL_POSITION_TYPE_ARRAY = (t: GetTextIdTranslationType) =>
  Object.keys(ProfessionalPosition).map((status) => ({
    value: status.toLowerCase(),
    display: t(status.toLowerCase()) || status.toLowerCase(),
  }));

export const COMPANY_ACTIVITY_TYPE_ARRAY = (t: GetTextIdTranslationType) =>
  Object.keys(CompanyActivity).map((status) => ({
    value: status.toLowerCase(),
    display: t(status.toLowerCase()) || status.toLowerCase(),
  }));

export const EMPLOYMENT_STATUS_FILTER = [
  EmploymentStatus.INDEFINITE_EMPLOYED,
  EmploymentStatus.TEMPORARY_EMPLOYED,
  EmploymentStatus.FIXED_DISCONTINUOUS_EMPLOYED,
  EmploymentStatus.CIVIL_SERVANT,
  EmploymentStatus.TRAINEE,
  EmploymentStatus.CASUALTY_WORKER,
  EmploymentStatus.SELF_EMPLOYED,
];

export const CIF_REQUIRED_EMPLOYMENT_STATUS = [
  EmploymentStatus.INDEFINITE_EMPLOYED,
  EmploymentStatus.TEMPORARY_EMPLOYED,
  EmploymentStatus.CIVIL_SERVANT,
  EmploymentStatus.TRAINEE,
  EmploymentStatus.CASUALTY_WORKER,
];
